// @ts-nocheck
import { useMemo } from 'react'
import { type FormInstance } from 'antd'
import { postApi } from 'src/api'
import { I18NS } from 'src/utils'

interface DenserPeriodUtilsParams {
  formRef: React.MutableRefObject<FormInstance<{
    oldPassword: string,
    password: string,
    password2: string
  }>>,
}

const userId = (function(){
  const index = location.href.indexOf('?')
  const search = location.href.slice(index + 1)
  return new URLSearchParams(search).get('loginId')
})()

export function useDenserPeriodUtils({ formRef }: DenserPeriodUtilsParams) {
  return useMemo(() => {
    return new class {
      finish = livecloud.debounce(async () => {
        try {
          const { oldPassword, password } = await formRef.current.validateFields()
          window.AES.setSecret('liveid-core')
          const res = await postApi('/password/updatePwd')({
            loginId:       userId,
            encryptOldPwd: window.AES.encryptBase64(oldPassword),
            encryptNewPwd: window.AES.encryptBase64(password)
          })
          const { code, note } = res
          if (code !== 1) {
            // livecloud.tip.error(note)
          } else {
            livecloud.tip.info(I18NS.RELOGIN_WORD)
            setTimeout(() => {
              this.removeParamsAndRedirect()
            }, 1000)
          }
        } catch (e) {
          console.log(e)
        }
      }, 100)

      removeParamsAndRedirect() {
        let url = window.location.href
        let urlObject = new URL(url)
        urlObject.searchParams.delete('pageType')
        urlObject.searchParams.delete('loginId')
        window.location.replace(urlObject.toString())
      }
    
    }

  }, [])
}